import styled from 'styled-components';
import variaveis from '../../styles/variaveis.scss';
import { ReactComponent as Logo } from '../../assets/logo/logo.svg';

export const Form = styled.form`
	p {
		color: #ff3333;
		margin-bottom: 15px;
		border: 1px solid #ff3333;
		padding: 10px;
		width: 100%;
		text-align: center;
		border-radius: 2rem;
	}
	a {
		font-size: 16;
		font-weight: bold;
		color: #999;
		text-decoration: none;
	}
`;

export const LogoStyle = styled(Logo)`
	fill: ${variaveis.primaryColor};
	width: 500px;
`;
